module.exports = __webpack_public_path__ + "img/hands.e143b3f6.svg";